import type { SearchLocation } from 'modules/search/types/SearchLocation';

export function isLocationEmpty(s: SearchLocation | null | undefined) {
  if (!s) return true;

  const { hasGeo, ...rest } = s;

  return Object.values(rest).every((o) => o === null) && !hasGeo;
}
